const HOST_MAP = /* @__PURE__ */ new Map([
  ["local", "https://www.dev.tvbanywhere.com/"],
  ["dev", "https://www.dev.tvbanywhere.com/"],
  ["qa", "https://www.qa.tvbanywhere.com/tc/webtv"],
  ["prod", "https://www.tvbanywhere.com/tc/webtv"]
]);
const A_HOST_MAP = /* @__PURE__ */ new Map([
  ["local", "https://www.dev.tvbanywhere.com"],
  ["dev", "https://www.dev.tvbanywhere.com"],
  ["qa", "https://www.qa.tvbanywhere.com"],
  ["prod", "https://www.tvbanywhere.com"]
]);
const U_API_BASE_MAP = /* @__PURE__ */ new Map([
  ["local", "https://uapisfm.qa.tvbanywhere.com.sg"],
  ["dev", "https://uapisfm.qa.tvbanywhere.com.sg"],
  ["qa", "https://uapisfm.qa.tvbanywhere.com.sg"],
  ["prod", "https://uapisfm.tvbanywhere.com.sg"]
]);
const API_BASE_MAP = /* @__PURE__ */ new Map([
  ["local", "https://apisfm.qa.tvbanywhere.com.sg"],
  ["dev", "https://apisfm.qa.tvbanywhere.com.sg"],
  ["qa", "https://apisfm.qa.tvbanywhere.com.sg"],
  ["prod", "https://apisfm.tvbanywhere.com.sg"]
]);
const PUBLIC_URL_MAP = /* @__PURE__ */ new Map([
  ["local", ""],
  ["dev", "https://www.dev.tvbanywhere.com"],
  ["qa", "https://www.qa.tvbanywhere.com/tc/webtv"],
  ["prod", "https://www.tvbanywhere.com/tc/webtv"]
]);
const ANYWHERE_URL_MAP = /* @__PURE__ */ new Map([
  ["local", ""],
  ["dev", "https://www.qa.tvbanywhere.com"],
  ["qa", "https://www.qa.tvbanywhere.com"],
  ["prod", "https://www.tvbanywhere.com"]
]);
const JETSO_URL_MAP = /* @__PURE__ */ new Map([
  ["local", "https://jetso.qa.tvbanywhere.com"],
  ["dev", "https://jetso.qa.tvbanywhere.com"],
  ["qa", "https://jetso.qa.tvbanywhere.com"],
  ["prod", "https://jetso.tvbanywhere.com"]
]);
const ZONE_URL_MAP = /* @__PURE__ */ new Map([
  ["local", "https://freezone.qa.tvbanywhere.com"],
  ["dev", "https://freezone.qa.tvbanywhere.com"],
  ["qa", "https://freezone.qa.tvbanywhere.com"],
  ["prod", "https://freezone.tvbanywhere.com"]
]);
const PLATFORM_MAP = /* @__PURE__ */ new Map([
  ["local", "webtv"],
  ["dev", "webtv"],
  ["qa", "webtv"],
  ["prod", "webtv"]
]);
const USER_SYSTEM_HOST_MAP = /* @__PURE__ */ new Map([
  ["local", "https://qa-id.tvbanywhere.com"],
  ["dev", "https://qa-id.tvbanywhere.com"],
  ["qa", "https://qa-id.tvbanywhere.com"],
  ["prod", "https://id.tvbanywhere.com"]
]);
const USER_SYSTEM_API_HOST_MAP = /* @__PURE__ */ new Map([
  ["local", "https://qa-id-api.tvb.com"],
  ["dev", "https://qa-id-api.tvb.com"],
  ["qa", "https://qa-id-api.tvb.com"],
  ["prod", "https://id-api.tvb.com"]
]);
const USER_SYSTEM_BOSS_API_HOST_MAP = /* @__PURE__ */ new Map([
  ["local", ""],
  ["dev", "https://apiboss.qa.tvbanywhere.com.sg"],
  ["qa", "https://apiboss.qa.tvbanywhere.com.sg"],
  ["prod", "https://apiboss.tvbanywhere.com.sg"]
]);
const DEVICE_TYPE_MAP = /* @__PURE__ */ new Map([
  ["local", "dev"],
  ["dev", "dev"],
  ["qa", "qa"],
  ["prod", "prod"]
]);

export { ANYWHERE_URL_MAP, API_BASE_MAP, A_HOST_MAP, DEVICE_TYPE_MAP, HOST_MAP, JETSO_URL_MAP, PLATFORM_MAP, PUBLIC_URL_MAP, USER_SYSTEM_API_HOST_MAP, USER_SYSTEM_BOSS_API_HOST_MAP, USER_SYSTEM_HOST_MAP, U_API_BASE_MAP, ZONE_URL_MAP };
//# sourceMappingURL=index.mjs.map
